import COOKIE from '../cookieConsent';
import { clientCookies } from 'utils/cookies';

export const USER_HID_DISCLAIMER = 'USER_HID_DISCLAIMER';

export function setUserHidDisclaimer() {
  return {
    type: USER_HID_DISCLAIMER,
  };
}

export function setCookieConsent() {
  clientCookies.set(COOKIE.name, COOKIE.value, COOKIE.options);
}
